import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/drop-down-arrow.svg'


const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "dropdown-header-content" }
const _hoisted_3 = { class: "header" }

import { toRefs } from 'vue'
interface Props {
  title: string
  isOpen: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownHeaderMapMenu',
  props: {
    title: {},
    isOpen: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { title, isOpen } = toRefs(props)
const onClick = (event?: Event, preventDefault?: boolean) => {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('toggle')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "aria-expanded": _unref(isOpen),
    class: _normalizeClass(["dropdown-header", { 'dropdown-header-expanded': _unref(isOpen) }]),
    role: "button",
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick())),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(($event: any) => (onClick()), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys((event) => onClick(event, true), ["space"]))
    ]
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(title)), 1),
      _createElementVNode("div", {
        class: _normalizeClass({ rotated: _unref(isOpen) })
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("img", { src: _imports_0 }, null, -1)
      ]), 2)
    ])
  ], 42, _hoisted_1))
}
}

})